import React from "react";

import { PrimaryButton } from "../../simple-buttons/simple-buttons";
import { SVGDeclineIcon } from "../../svg-animated/svg-animated";
import DocumentStatus from "./document-status";

const DocumentNotSupported = ({ resetJourney }: { resetJourney: () => Promise<void> }) => {
    return (
        <DocumentStatus
            icon={<SVGDeclineIcon />}
            headingText="Wrong document type detected"
            subheadingText="Sorry, we cannot complete your application with the document provided."
            paragraphText="Please resubmit, selecting a document from the 
            list of valid documents you will see in the next screen."
            button={<PrimaryButton onClick={() => resetJourney()} text="Try again" />}
        />
    )
};

export default DocumentNotSupported;
